module.exports = __webpack_public_path__ + "public/img/应急处理bg.12b56967.png";